<!-- <div class="header"> -->

<div class="grid grid-cols-9 gap-4 border-solid	border border-gray-300 dark:border-gray-500 rounded m-2 p-2 text-lg font-semibold uppercase text-gray-600 dark:text-white text-center items-center">

    <div>{{usuario?.nom_caseta}} {{usuario?.nom_carril}}<br></div>
    <div>T {{usuario?.turno}}<br>{{usuario?.id_corte_usuario}}</div>
    <div class="col-span-3">{{usuario?.nom_user}}</div>
    <div>{{ time | date: 'dd/MM/YYYY' }} <br> {{ time | date: 'hh:mm:ss a' }}</div>
    <button *ngIf="hasAnyDevolution()" class="bg-red-600 w-full text-lg uppercase dark:bg-red-600 rounded py-1 text-white dark:text-gray-50 font-semibold border-2 border-gray-300 drop-shadow-lg hover:border-red-600" [disabled]="isOffline" [class.dark:bg-gray-600] = "isOffline"
            [class.bg-gray-300] ="isOffline"
            [class.dark:bg-transparent] ="!isOffline" [style.cursor]="isOffline ? 'not-allowed' : 'pointer' "   (click)="cerrarSesion()">Corte</button>

    <div class="grid grid-cols-2 gap-2 place-items-center">
        <button>
          <!-- icon cuando no existe conexión -->
          <svg *ngIf="isOffline" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <!-- icon cuando  existe conexión -->
            <svg *ngIf="!isOffline" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
            </svg>
        </button>
        <span class="group cursor-pointer relative inline-block border-b border-gray-400 text-center">{{morrallaCount+btnRapidoCount+crucesCount+devolucionCount+retiroCount+rolloCount+boletoCount}}
          <div class="w-36 opacity-0 bg-black text-white text-center -left-18 top-9 text-xs rounded-lg py-2 absolute z-10 group-hover:opacity-100 px-3 pointer-events-none">
            <div class="flex flex-col text-left">
              <span>Morralla: {{morrallaCount}}</span>
              <span>Botones Rapidos: {{btnRapidoCount}}</span>
              <span>Cruces: {{crucesCount}}</span>
              <span>Devolucion: {{devolucionCount}}</span>
              <span>Retiro: {{retiroCount}}</span>
              <span>Rollo: {{rolloCount}}</span>
              <span>Boletos: {{boletoCount}}</span>
            </div>
          </div>
        </span>
    </div>
    <div class="grid grid-cols-2 gap-4  place-items-center">
      <app-reload-buttom></app-reload-buttom>
      <app-switch-theme></app-switch-theme>
    </div>



</div>





<!-- </div> -->
